import { useState, useEffect, useRef } from 'react';
import PreAIEditModal from './PreAIEditModal';
import styled, { css } from 'styled-components';

import { cookieParser, parseDraftText } from '/lib/helpers';
import Flex from '/imports/core/ui/atoms/Flex';
import { RTLLanguages } from '/imports/generator/api/constants';
import useIntl from '/imports/core/api/useIntl';
import useTracking from '/imports/core/hooks/useTracking';

const PreAIEdit = ({ container, source, item, type, updateSelectedPreAiText, data, currentStep }) => {
  const { token } = cookieParser();
  const { trackEvent } = useTracking();
  const { locale, t } = useIntl();
  const isRTL = RTLLanguages.includes(locale);
  const [open, setOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  useEffect(() => {
    updatePositions();
    const scrollDiv = document.getElementById('scroll-cont');
    if (scrollDiv) {
      scrollDiv.addEventListener('scroll', updatePositions);
    }
    window.addEventListener('resize', updatePositions);
    return () => {
      if (scrollDiv) {
        scrollDiv.removeEventListener('scroll', updatePositions);
      }
      window.removeEventListener('resize', updatePositions);
    };
  }, []);
  const updateModalPosition = () => {
    const containerPosition = container.current?.getBoundingClientRect();
    const newPosition = {
      top: containerPosition?.top - 100,
      left: isRTL ? containerPosition?.right - containerPosition?.width - 420 : containerPosition?.right,
    };
    setModalPosition(newPosition);
  };
  const updatePositions = () => {
    updateModalPosition();
  };

  const openAISuggestionsModal = async (e) => {
    e.preventDefault();
    setOpen(true);
    updateModalPosition();
  };
  const renderCTAIcon = () => {
    return (
      <IconWrapper>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_8734_101199)">
            <path
              d="M9.41551 8.57887L11.4861 10.6657C11.6605 10.8542 11.7477 11.0751 11.7477 11.3283C11.7477 11.5822 11.6605 11.7961 11.4861 11.97C11.2971 12.1585 11.0718 12.2528 10.8102 12.2528C10.5487 12.2528 10.3233 12.1585 10.1343 11.97L7.80212 9.64421C7.70098 9.54265 7.62495 9.43031 7.57403 9.30718C7.52311 9.18406 7.49765 9.05711 7.49765 8.92633V5.55709C7.49765 5.29623 7.59181 5.07154 7.78015 4.88303C7.96918 4.69451 8.19448 4.60026 8.45606 4.60026C8.71763 4.60026 8.94293 4.69451 9.13196 4.88303C9.321 5.07154 9.41551 5.29623 9.41551 5.55709V8.57887ZM8.5 16.9482C6.72687 16.9482 5.12464 16.4338 3.6933 15.405C2.26197 14.3755 1.29937 13.0131 0.805519 11.3179C0.718327 11.0278 0.747275 10.7523 0.892362 10.4915C1.03815 10.2306 1.25613 10.064 1.5463 9.99168C1.83717 9.93394 2.09526 9.99933 2.32056 10.1878C2.54586 10.3757 2.70908 10.6073 2.81023 10.8828C3.21759 12.1001 3.94442 13.0712 4.99071 13.796C6.03701 14.5209 7.20677 14.8833 8.5 14.8833C10.1566 14.8833 11.559 14.307 12.7072 13.1543C13.8553 12.0024 14.4294 10.6003 14.4294 8.94824C14.4294 7.29614 13.8553 5.89411 12.7072 4.74216C11.559 3.58952 10.1566 3.0132 8.5 3.0132C7.54089 3.0132 6.63271 3.23093 5.77544 3.66639C4.91817 4.10045 4.21331 4.70912 3.66087 5.49239H4.85993C5.10685 5.49239 5.32832 5.5863 5.52433 5.77412C5.72103 5.96263 5.81938 6.18732 5.81938 6.44818C5.81938 6.70904 5.72103 6.93372 5.52433 7.12223C5.32832 7.31075 5.10685 7.405 4.85993 7.405H1.5463C1.25613 7.405 1.0092 7.30344 0.805519 7.10032C0.60184 6.8979 0.5 6.65165 0.5 6.36157V2.88381C0.5 2.62226 0.594516 2.39757 0.783547 2.20975C0.972578 2.02124 1.19788 1.92698 1.45946 1.92698C1.72103 1.92698 1.94633 2.02124 2.13536 2.20975C2.3244 2.39757 2.41891 2.62226 2.41891 2.88381V3.70917C3.15969 2.79651 4.06055 2.10819 5.1215 1.64421C6.18245 1.18023 7.30861 0.948242 8.5 0.948242C9.58955 0.948242 10.6212 1.15484 11.595 1.56804C12.5687 1.98124 13.4225 2.55026 14.1563 3.2751C14.8901 3.99924 15.4642 4.85033 15.8785 5.82838C16.2928 6.80712 16.5 7.83977 16.5 8.92633C16.5 10.0275 16.2928 11.0675 15.8785 12.0462C15.4642 13.0242 14.8901 13.8757 14.1563 14.6005C13.4225 15.3247 12.5725 15.8968 11.6065 16.317C10.6397 16.7378 9.60419 16.9482 8.5 16.9482Z"
              fill="#FF9900"
            />
          </g>
          <defs>
            <clipPath id="clip0_8734_101199">
              <rect width="16" height="16" fill="white" transform="translate(0.5 0.948242)" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    );
  };
  return (
    <>
      <PreAIEditButton onClick={openAISuggestionsModal}>
        <PreAIEditButtonFlex alignItems="center">
          {renderCTAIcon()}
          {t('generator_pre_ai_edit_text')}
        </PreAIEditButtonFlex>
      </PreAIEditButton>
      <PreAIEditModal
        open={open}
        data={data}
        currentStep={currentStep}
        setOpen={setOpen}
        modalPosition={modalPosition}
        updateSelectedPreAiText={updateSelectedPreAiText}
      />
    </>
  );
};
export default PreAIEdit;
const PreAIEditButton = styled.button`
  position: absolute;
  right: 20px;
  top: -40px;
  z-index: 9999;
  display: flex;
  flex-shrink: 0;
  padding: 8px 16px;
  align-items: center;
  justify-content: center;

  background: #fff;
  border: 1px solid #f90;
  border-radius: 4px;
  cursor: pointer;
  height: 32px;

  color: #ff9900;
  font-family: Gilroy SemiBold;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      left: 25px;
      right: inherit;
    `}
  &:hover {
    background-color: #fcfcfc;
  }
  &:active {
    background-color: #f5f5f5;
  }
  ${(p) =>
    p.disabledStyle &&
    css`
      cursor: default;
      background: #dbdee9;
      box-shadow: 0px 5px 21px 0px rgba(20, 20, 31, 0.12);
      color: #8d93a5;
      path {
        stroke: #8d93a5;
        fill: #8d93a5;
      }
      &:hover {
        background-color: #dbdee9;
      }
      &:active {
        background-color: #dbdee9;
      }
    `}
  @media (max-width: 449px) {
    right: 5px;
  }
`;
const PreAIEditButtonFlex = styled(Flex)`
  gap: 10px;
`;

const IconWrapper = styled(Flex)`
  flex-shrink: 0;
`;
